import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Kode', value: 'code' },
  { text: 'Definisi', value: 'definition'},
  { text: 'Create Date', value: 'created_at'},
  { text: 'Last Update', value: 'updated_at'},
  { text: 'Action', value: 'action', width: '10' },
]);

export const search = {
  code: '',
  definition: '',
  created_at: '',
  updated_at: '',
};